import React from '../../vendor/react';
export function SalesChart({ values }: { values: number[] }) {
  const max = Math.max(1, ...values);
  const labels = ['8a', '9a', '10a', '11a', '12p', '1p', '2p', '3p', '4p', '5p', '6p', '7p'];
  return (
    <div className="sales-chart" aria-label="Ventas por hora">
      <div className="sales-chart__grid"><span>Máx.</span><span>Mitad</span><span>$0</span></div>
      <div className="sales-chart__bars">
        {values.map((value, index) => (
          <div className="sales-chart__column" key={`${labels[index]}-${value}`}>
            <div className="sales-chart__bar-wrap"><span className="sales-chart__bar" style={{ height: `${value === 0 ? 0 : Math.max(8, (value / max) * 100)}%` }} /></div>
            <small>{labels[index]}</small>
          </div>
        ))}
      </div>
    </div>
  );
}
